import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronDownSmall, ChevronUpSmall} from '@wix/wix-ui-icons-common'
import classNames from 'classnames'
import React, {useState} from 'react'
import {HoverStyles, Text, TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import xss from 'xss'
import {useSettings} from '../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import {useColors} from '../../../hooks/colors'
import {useModal} from '../../../hooks/modal'
import {useWidgetProps} from '../../../hooks/widget-props'
import {classes as c} from './description.st.css'
import {DescriptionProps} from './interfaces'

export const Description = ({text, itemId}: DescriptionProps) => {
  const {insideModal} = useModal()
  const {readDescriptionClicked} = useWidgetProps()
  const [opened, toggle] = useState(false)
  const settings = useSettings()
  const {isDarkLinkColor} = useColors()
  const readMoreText = settings.get(settingsParams.readMore) as string
  const readLessText = settings.get(settingsParams.readLess) as string

  const wired = isDarkLinkColor()

  const handleReadMore = () => {
    const newOpened = !opened

    if (newOpened) {
      readDescriptionClicked({itemId})
    }

    toggle(newOpened)
  }

  return (
    <div className={c.container}>
      <TextButton
        className={classNames({
          [c.blackButton]: insideModal && !wired,
          [c.defaultButton]: !insideModal || wired,
        })}
        priority={TextButtonPriority.primary}
        hoverStyle={HoverStyles.underline}
        data-hook={DH.DESCRIPTION_BUTTON}
        onClick={handleReadMore}
        suffixIcon={opened ? <ChevronUpSmall /> : <ChevronDownSmall />}
        aria-expanded={opened}
      >
        {opened ? readLessText : readMoreText}
      </TextButton>
      {opened && (
        <Text
          className={classNames(c.text, {[c.defaultText]: !insideModal, [c.blackText]: insideModal})}
          data-hook={DH.DESCRIPTION}
        >
          <div dangerouslySetInnerHTML={{__html: xss(text)}} />
        </Text>
      )}
    </div>
  )
}
